module.exports = __webpack_public_path__ + "img/20220415_110111.370bbd55.jpg";